<template>
  <modal-form v-model="show" size="md" :key="model.Codigo"
              :show-submit="false"
              text-close="Fechar">
    <template v-slot:title>
      <v-icon class="mr-2">fas fa-list</v-icon>
      Parcelas da Proposta
    </template>
    <template v-slot:body>
      <core-grid v-if="show" ref="grid" :onRead="onRead" :schema="schema" mobile-breakpoint="0" modal flat hide-all-options  grid-role="ListPropostaParcela">
        <template v-slot:[`item.NumeroBoleto`]="{item}">
          <a @click="imprimirFormaPagamento(item, 'Boleto')"> {{$api.UI.Format.LeftPadNumbers(item.NumeroBoleto, 8)}}</a>
        </template>
      </core-grid>

      <PropostaParcelaEmail ref="email" @close="response"></PropostaParcelaEmail>

    </template>
    <template v-slot:actions v-if="loaded && (permiteGerarParcela || parcelasGeradas)">
      <div class="flex-grow-1"></div>
      <v-btn small light @click="close">Fechar</v-btn>
      <v-btn small v-if="userHasRole('EnviarPorEmailPropostaParcela') && parcelasGeradas" dark @click="enviarPorEmail" color="primary">
        <v-icon class="mr-2" small>fas fa-paper-plane</v-icon>
        Enviar Por E-mail
      </v-btn>
      <v-menu  v-if="parcelasGeradas" top offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="ml-2" small dark color="primary" v-bind="attrs" v-on="on">
              <v-icon class="mr-2" small>fas fa-print</v-icon>
              Imprimir
            </v-btn>
          </template>
          <v-list>
              <v-list-item v-for="tipo in itens" :key="tipo.name">
                <v-btn @click="tipo.acao('all', tipo.name)" plain>{{ tipo.name }}</v-btn>
              </v-list-item>
          </v-list>
      </v-menu>
      <v-btn small v-if="userHasRole('GerarParcelasProposta') && permiteGerarParcela && !parcelasGeradas" dark @click="gerarParcelas" color="primary">
        Gerar Parcelas
      </v-btn>

    </template>
  </modal-form>

</template>
<script>
export default {
  components: {
    PropostaParcelaEmail: () => import('./PropostaParcelaEmail'),
  },
  data () {
    return {
      show: false,
      parcelasGeradas: false,
      permiteGerarParcela: false,
      loaded: false,
      model: {},
      itens: [
        { name: 'Carnê', acao: this.imprimirFormaPagamento },
        { name: 'Boleto', acao: this.imprimirFormaPagamento }
      ],
      schema: [
        { value: 'NumeroParcela', text: 'Parcela', template: p => '# ' + (p.NumeroParcela + 1) },
        { value: 'DtVencimento', text: 'Vencimento', format: 'date', align: 'center' },
        { value: 'VlrParcela', text: 'Valor Parcela', format: 'decimal' },
        { value: 'NumeroBoleto', text: 'Nro Boleto', align: 'center' },
        { value: 'DtCredito', text: 'Pago Em' },
        { value: 'Cancelada' }
      ]
    }
  },
  methods: {
    openModal (sender) {
      const th = this
      th.model = sender
      th.parcelasGeradas = false
      th.loaded = false
      th.$api.Multiplo.FindRecordProdutoRede().then(function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          const permite =
          ([th.$aux.SituacaoPropostaEnum.Aprovada, th.$aux.SituacaoPropostaEnum.Finalizada].some(p => p === th.model.Situacao) ||
          (response.GerarParcelaLiberacao && th.model.Situacao > th.$aux.SituacaoPropostaEnum.Finalizada))

          th.$set(th, 'permiteGerarParcela', permite)
        }
        th.show = true
      })
    },
    onRead: function (options, search) {
      const th = this
      if (th.model.Codigo) {
        const dto = { parameters: [{ name: 'CodigoProposta', value: th.model.Codigo }] }
        th.$api.Multiplo.ListPropostaParcela(dto).then(function (response) {
          if (th.$api.UI.PostLoadData(response)) {
            options.success(response.Data)
            th.parcelasGeradas = response.Data.length > 0
          }
          th.loaded = true
        })
      } else {
        options.success([])
      }
    },
    close () {
      this.show = false
      this.$emit('close')
    },
    gerarParcelas () {
      const th = this
      const dto = { guidID: th.model.Codigo }
      th.$api.Multiplo.GerarParcelasProposta(dto).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          th.refresh()
        }
      })
    },
    enviarPorEmail (e) {
      e.preventDefault()
      this.$refs.email.openModal(this.model)
    },
    urlImprimirAll () {
      const baseURL = process.env.VUE_APP_ROOT.includes('.dev.') ? 'https://reports.moneyp.dev.br/' : 'https://reports.moneyp.com.br/'
      return baseURL + `ImprimirBoleto?proposta=${this.model.Codigo}&type=all&FC=`
    },
    imprimirFormaPagamento (current, type) {
      const url = `${process.env.VUE_APP_ROOT_WEBURL}imprimirboleto.aspx?type=PD&code=${current.Codigo}`
      switch (type) {
        case 'Boleto':
          if (current === 'all') {
            window.open(`${this.urlImprimirAll()}N`)
          } else {
            window.open(url)
          }
          break;
        case 'Carnê':
          window.open(`${this.urlImprimirAll()}S`)
      }
    },
    refresh: function () {
      this.$refs.grid.refresh()
    },
    response: function (data) {
      if (data) { this.refresh() }
    }
  },
}
</script>
